import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import CollapseHeader from "../../../../core/common/collapse-header/collapse-header";
import CopyRightInfo from "../../../../core/common/copyRightInfo";
import CommonSelectV2 from "../../../../core/common/commonSelectV2";
import useFetch from "../../../../hooks/useFetch";
import { API } from "../../../../common/Constants";
import { getAPIHeaders } from "../../../../common/Utils";
import ChatSettingsMenu from "./common/chat-setting-menu";
import { ChatTokenTopup, FeatureCredit, RoleCredit } from "../../../../types/dataModel";
import PreLoader from "../../../../core/common/preLoader";
import CustomToast from "../../../../core/common/customToast";
import CommonTabMenu from "../commonTabMenu";

const ChatTopupSettings = () => {
  const routes = all_routes;

  const { isLoading, error, callFetch } = useFetch();
  const [chatTokenLimits, setChatTokenLimits] = React.useState<FeatureCredit>({});
  const [chatTokenTopup, setChatTokenTopup] = React.useState<ChatTokenTopup>();
  const [toastSettings, setToastSettings] = React.useState<{
    show: boolean;
    message: string;
    heading: string;
    type: "ERROR" | "SUCCESS" | "INFO" | "";
  }>({
    show: false,
    message: "",
    heading: "",
    type: "ERROR",
  });
  const [costInINR, setCostInINR] = React.useState<number>(0);

  React.useEffect(() => {
    fetchFeatureTokenLimits();
  }, []);

  React.useEffect(() => {
      if (error) {
        if (error.response?.data) {
          setToastSettings({
            message: error?.response?.data,
            heading: "Ooops",
            show: true,
            type: "ERROR"
          })
        } else {
          setToastSettings({
            message: 'Something went wrong please try again later.',
            heading: "Ooops",
            show: true,
            type: "ERROR"
          })
        }
      }
  }, [error]);
  
  const fetchFeatureTokenLimits = () => {
    callFetch(API.SETTINGS_AI_FEATURE_LIMITS,
      'GET',
      getAPIHeaders(),
      null,
      null
    ).then((res) => {
      setChatTokenLimits(res?.AI_CA_001[0])
    }).catch((err) => {});
  }

  const saveTokenTopup = (e:any) => {
    e.preventDefault();
    if (!chatTokenTopup?.tokens === undefined || !chatTokenTopup?.reason) {
      setToastSettings({
        message: 'Please fill all the fields.',
        heading: "Error",
        show: true,
        type: "ERROR"
      });
      return;
    }
    if (chatTokenTopup?.tokens !== undefined && chatTokenTopup?.tokens <= 0) {
      setToastSettings({
        message: 'Token count should be greater than 0.',
        heading: "Error",
        show: true,
        type: "ERROR"
      });
      return;
    }

    callFetch(API.SETTINGS_AI_TOKEN_TOPUP,
      'POST',
      getAPIHeaders(),
      null,
      {
        tokens: chatTokenTopup?.tokens,
        reason: chatTokenTopup?.reason,
        featureCode: "AI_CA_001"
      }
    ).then((res) => {
      setToastSettings({
        message: 'Chat token topup added successfully.',
        heading: "Success",
        show: true,
        type: "SUCCESS"
      });
      fetchFeatureTokenLimits();
    }).catch((err) => {});
  }

  const onToastClose = () => {
    setToastSettings({
      show: false,
      message: "",
      heading: "",
      type: "",
    });
  };

  const estimateCostInInr = () => {
    callFetch(API.AI_FEATURE_COST_ESTIMATE.replace(':featureId', 'AI_CA_001'),
      'POST',
      getAPIHeaders(),
      {
        tokenCount: chatTokenTopup?.tokens,
      },
      null
    ).then((res) => {
      setCostInINR(res);
    }).catch((err) => {});
  }

  return (
    <div>
      <>
        <CustomToast
        show={toastSettings?.show}
        message={toastSettings?.message}
        heading={toastSettings?.heading}
        type={toastSettings?.type || "INFO"}
        onClose={onToastClose} />
        <PreLoader showLoader={isLoading} />
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Chat Settings</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Administration</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Settings
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
            {/* /Breadcrumb */}
            <CommonTabMenu activeTab="Chat" />
            <div className="row">
              <div className="col-xl-3 theiaStickySidebar">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex flex-column list-group settings-list">
                       <ChatSettingsMenu activeTab="chatTokenTopup" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-9">
                <div className="card">
                  <div className="card-body">
                    <div className="border-bottom mb-3 pb-3">
                      <h4>Chat Token Topup For Month</h4>
                    </div>
                    <form>
                      <div className="border-bottom mb-3">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="row align-items-center">
                              <div className="col-lg-4">
                                <div className="mb-3">
                                  <h6 className="mb-2 fw-medium">Token Limit</h6>
                                </div>
                              </div>
                              <div className="col-lg-4">
                                <div className="mb-3">
                                 {chatTokenLimits?.tokenLimit || 0} ({(chatTokenLimits?.tokenLimitCostInr || 0).toFixed(2)} INR)
                                </div>
                              </div>
                            </div>
                            <div className="row align-items-center">
                              <div className="col-lg-4">
                                <div className="mb-3">
                                  <h6 className="mb-2 fw-medium">Topup Token Count</h6>
                                </div>
                              </div>
                              <div className="col-lg-4">
                                <div className="mb-3">
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Enter Token Count"
                                    min="0"
                                    value={chatTokenTopup?.tokens || ''}
                                    onChange={(e) => {
                                      const value = e.target.value ? parseInt(e.target.value, 10) : undefined;
                                      setChatTokenTopup({
                                        ...chatTokenTopup,
                                        tokens: value,
                                      } as ChatTokenTopup);
                                    }}
                                    onKeyUpCapture={estimateCostInInr}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-4">
                                <div className="mb-3">
                                  <h6 className="mb-2 fw-medium">Cost in INR {costInINR}</h6>
                                </div>
                              </div>
                            </div>
                            <div className="row align-items-center">
                              <div className="col-lg-4">
                                <div className="mb-3">
                                  <h6 className="mb-2 fw-medium">Topup Reason</h6>
                                </div>
                              </div>
                              <div className="col-lg-4">
                                <div className="mb-3">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Reason For Topup"
                                    value={chatTokenTopup?.reason}
                                    onChange={(e) => {
                                      setChatTokenTopup({
                                        ...chatTokenTopup,
                                        reason: e.target.value,
                                      } as ChatTokenTopup);
                                    }}
                                  />
                                </div>
                              </div>
             
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-end">
                        <button
                          type="button"
                          className="btn btn-outline-light border me-3"
                          onClick={() => {
                            setChatTokenTopup({
                              roleId: undefined,
                              tokensToAdd: 0,
                              reason: "",
                            } as ChatTokenTopup);
                          }}
                        >
                          Cancel
                        </button>
                        <button type="submit" 
                        className="btn btn-primary" 
                        onClick={saveTokenTopup}>
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
            <CopyRightInfo/>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>

    </div>
  );
};

export default ChatTopupSettings;